import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityApiVolumeByApplicationSlice } from './get';

export const coreDataSecurityApiVolumeByApplicationReducers = combineReducers({
	get: getCoreDataSecurityApiVolumeByApplicationSlice.asyncReducers
});

export const coreDataSecurityApiVolumeByApplicationWatchers = combineAllWatchers([
	getCoreDataSecurityApiVolumeByApplicationSlice.asyncWatchers
]);
